import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetSportsGroupedByDate = QueryFactory(SD.QueryTypes.GetSportsGroupedByDate);
//# sourceMappingURL=QGetSportsGroupedByDate.js.map